"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPreferencesACSConfigClientImpl = /** @class */ (function () {
    function I18nPreferencesACSConfigClientImpl(configSet) {
        this.configSet = configSet;
    }
    I18nPreferencesACSConfigClientImpl.prototype.getDefaultLanguage = function (context, weblabContext) {
        return this.configSet.getString("default_language", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getDefaultCurrency = function (context, weblabContext) {
        return this.configSet.getString("default_currency", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getSupportedLanguages = function (context, weblabContext) {
        return this.configSet.getList("supported_languages", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getSupportedCurrencies = function (context, weblabContext) {
        return this.configSet.getList("supported_currencies", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getAvailableLanguages = function (context, weblabContext) {
        return this.configSet.getList("available_languages", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getAvailableCurrencies = function (context, weblabContext) {
        return this.configSet.getList("available_currencies", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getPopularLanguages = function (context, weblabContext) {
        return this.configSet.getList("popular_languages", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPreferencesACSConfigClientImpl.prototype.getPopularCurrencies = function (context, weblabContext) {
        return this.configSet.getList("popular_currencies", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return I18nPreferencesACSConfigClientImpl;
}());
exports.default = I18nPreferencesACSConfigClientImpl;
